// src/auth/ProtectedRoute.js
//
// Wrap any route element with this to require a logged-in session.
// If the person isn't authenticated, they're bounced to /caretaker-login
// and the page they were trying to reach is remembered (location.state.from)
// so LoginPage can send them back after a successful sign-in.
//
// Usage in your routes file:
//
//   <Route
//     path="/care-coordinator/program"
//     element={
//       <ProtectedRoute>
//         <ProgramOverview />
//       </ProtectedRoute>
//     }
//   />

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/caretaker-login" replace state={{ from: location }} />;
  }

  return children;
}